module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-2-sm-011fbc3c2df4b3e5e170e3e74815852d.png";